import {useReducer} from 'react';
import {isEmpty} from 'lodash/lang';

export const useFormSubmitting = (options) => {
  const {
    submitFn,
    onSuccess,
    form: {validateFields},
    formatErrors,
    addFlashMessage,
    successMsg = 'Form submitted successfully',
  } = options;
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'SUBMIT_FORM':
          return {
            ...state,
            submitting: true,
          };
        case 'SUBMIT_SUCCEEDED':
          return {
            ...state,
            submitting: false,
          };
        case 'SUBMIT_FAILED':
          return {
            errors: action.errors || {},
            submitting: false,
          };
        default:
          return state;
      }
    },
    {submitting: false, errors: {}},
  );

  const handleFormSubmit = (e) => {
    e.preventDefault();
    validateFields((error, value) => {
      if (isEmpty(error)) {
        dispatch({type: 'SUBMIT_FORM'});
        submitFn(value)
          .then((response) => {
            onSuccess && onSuccess(response);
            dispatch({type: 'SUBMIT_SUCCEEDED'});
            addFlashMessage(successMsg, 'success');
          })
          .catch((error) => formatErrors(error).then((errors) => dispatch({type: 'SUBMIT_FAILED', errors})));
      }
    });
  };

  return {
    ...state,
    handleFormSubmit,
  };
};
